import * as React from 'react';

var _path, _path2;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var SvgReturns = function SvgReturns(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        "aria-hidden": "true"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M8.785.22a.75.75 0 0 1 0 1.06L5.565 4.5h11.376l-3.218-3.218a.75.75 0 0 1 1.06-1.06L19.062 4.5H20.352a2.234 2.234 0 0 1 2.083 2.796l-.298 1.248a.75.75 0 1 1-1.459-.349l.3-1.256.005-.017A.735.735 0 0 0 20.309 6h-1.553a.72.72 0 0 1-.01 0H2.198a.734.734 0 0 0-.673.921l.005.02 2.137 8.999.004.014c.067.312.34.537.658.545H7.88a.75.75 0 0 1 0 1.5H4.306a2.192 2.192 0 0 1-2.1-1.719L.072 7.296A2.234 2.234 0 0 1 2.182 4.5h1.263L7.725.22a.75.75 0 0 1 1.06 0Z"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M17.435 12.01a4.82 4.82 0 0 0-4.89 3.25.75.75 0 1 1-1.418-.486 6.32 6.32 0 0 1 11.373-1.25v-1.525a.75.75 0 1 1 1.5 0v3.75a.75.75 0 0 1-.75.75h-3.749a.75.75 0 0 1 0-1.5h2.07a4.822 4.822 0 0 0-4.136-2.99ZM12.003 22.499v-1.524a6.32 6.32 0 0 0 11.374-1.25.75.75 0 0 0-1.419-.486 4.82 4.82 0 0 1-9.025.26h2.07a.75.75 0 0 0 0-1.5H11.253a.75.75 0 0 0-.75.75v3.75a.75.75 0 1 0 1.5 0Z"
    })));
};

export { SvgReturns as default };
//# sourceMappingURL=returns-8050ef18.js.map
